import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { WalletFilters } from '../models'

import getAllWalletExtraReducer from '../thunks/get-all.thunk'
import setManualBonusExtraReducer from '../thunks/set-manual-bonus.thunk'
import syncBetsoftBonusExtraReducer from '../thunks/sync-betsoft-bonus.thunk'

import initialState from './initial-state'
import { getBonusBalanceExtraReducer } from '../thunks/get-bonus-balance.thunk'

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setWalletFiltersAction(state, action: PayloadAction<WalletFilters>) {
      state.filters = action.payload
    },
    setFreePlaysCalculatedAction(state, action: PayloadAction<string>) {
      const newFreePlaysCalculated = state.freePlaysCalculated.filter(
        (item) => item.playerId !== action.payload,
      )

      const date = new Date()

      newFreePlaysCalculated.push({
        playerId: action.payload,
        timestamp: date.toISOString(),
      })
      state.freePlaysCalculated = newFreePlaysCalculated
    },
    resetFreePlaysCalculated(state) {
      state.freePlaysCalculated = []
    },
  },
  extraReducers: (builder) => {
    getAllWalletExtraReducer(builder)
    setManualBonusExtraReducer(builder)
    syncBetsoftBonusExtraReducer(builder)
    getBonusBalanceExtraReducer(builder)
  },
})

export const WalletActions = walletSlice.actions

export const walletsSelector = ({ wallet }: ApplicationState) => wallet

export default walletSlice
